import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Connect } from '../../../classes/connect';
import { ApiResponse } from '../../../interfaces/api-response';
import { ConnectServerService } from '../../../services/connect-server.service';
import { PopupDialogService } from '../../../services/popup-dialog.service';

interface ArtisticDefinitionRow {
  id: number;
  name: string;
  code: string;
  filename: string | null;
  updated_at: string;
}

@Component({
  selector: 'app-import-artistic-definition',
  imports: [AsyncPipe],
  templateUrl: './import-artistic-definition.component.html',
  styleUrl: './import-artistic-definition.component.scss'
})
export class ImportArtisticDefinitionComponent implements OnInit {
  readonly connectServerService = inject(ConnectServerService);
  readonly popupDialogService = inject(PopupDialogService);

  dataSource$!: Observable<ArtisticDefinitionRow[]>;

  ngOnInit(): void {
    this.dataSource$ = this.connectServerService.getRequest<ArtisticDefinitionRow[]>(
      'listArtisticTable',
      {}
    );
  }

  uploadFiles(event: Event, tablename: string, id: number): void {
    const input = event.target as HTMLInputElement;
    const files = input.files;
    if (!files) {
      return;
    }

    let messaggio = '';
    for (const file of Array.from(files)) {
      if (file.size < Connect.sizeFileExcel) {
        const formData = new FormData();
        formData.append('allegato', file);
        formData.append('table_name', tablename);
        formData.append('idtable', String(id));
        this.connectServerService
          .postRequest('importArtisticDefinition', formData)
          .subscribe((res: ApiResponse<any>) => {
            this.popupDialogService.popupDialog(res);
            this.ngOnInit();
          });
      } else {
        messaggio += `Impossibile caricare il file ${file.name}\n`;
      }
    }

    if (messaggio.length > 0) {
      alert(`${messaggio}Dimensione consentita per ogni file: ${Connect.str_sizeFileExcel}\n`);
    }

    input.value = '';
  }
}
